module.exports = __webpack_public_path__ + "static/img/KY-jly.cded5a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/KY-jly.png
// module id = i21h
// module chunks = 1